import Sunny16BaseService from '@/services/Sunny16BaseService'

class Sunny16CommerceContentService extends Sunny16BaseService {
  constructor() {
    super(import.meta.env.VITE_SUNNY_16_CONTENT_API_BASE_URL)
  }

  async getBundle(bundleId: string) {
    try {
      const response = await this.axiosInstance.get(`/bundle/${bundleId}`)
      return response.data
    } catch (error) {
      console.error('Error fetching bundle:', error)
      throw error
    }
  }

  async getCatalog(catalogId: string) {
    try {
      // Lean drops Contentful sys/$metadata and null fields (#1622); catalog content never reads them.
      const response = await this.axiosInstance.get(`/catalog/${catalogId}`, {
        params: { lean: true }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching catalog:', error)
      throw error
    }
  }

  async getCartContent(cartId: string, securityKey: string) {
    try {
      const response = await this.axiosInstance.get(`/cart/${cartId}/${securityKey}`)
      return response.data
    } catch (error) {
      console.error('Error fetching cart content:', error)
      throw error
    }
  }

  async getArbitraryContent(contentTypeId: string, identifier: string) {
    try {
      const response = await this.axiosInstance.get(
        `/arbitrary/${contentTypeId}/${encodeURIComponent(identifier)}`
      )
      return response.data
    } catch (error) {
      console.error('Error fetching arbitrary content:', error)
      throw error
    }
  }
}

export default Sunny16CommerceContentService
